/* eslint-disable sort-keys */
/* eslint-disable react/jsx-sort-default-props */
import {
    radioButton, radioWrapper,
    radioWrapperInner,
} from './styles'

import React from 'react'

import {styled} from 'stitches/config'

const StyledRadioWrapper = styled('div', radioWrapper)
const StyledRadioWrapperInner = styled('div', radioWrapperInner)
const StyledRadioButton = styled('div', radioButton)

export interface QuestionnaireRadioProps {
    align?: 'right' | 'center' | 'left',
    delay?: number
    lightBot?: boolean
    clearAfter?: boolean
    currentElement?: boolean
    textAlign?: 'left' | 'right' | 'center'
    id: string
    hide?: boolean
    text?: string
    name: string
    readableName?: string
    groupName?: string
    maxWidth?: string
    margin?: string
    padding?: string
    value: string
    checked?: boolean
    inline?: boolean
    errorId?: string
    iconLeft?: {
        src?: string
        svg?: string
    }
    iconRight?: {
        src?: string
        svg?: string
    }
    onClick: () => void
    onChange: (params: {name: string, value: boolean | string, readableName?: string, groupName?: string }) => void
}

export const QuestionnaireRadio = (props: QuestionnaireRadioProps) => {
    const {
        text, id, value, onClick, errorId,
        onChange, name, checked, clearAfter,
        inline, hide, readableName,
        groupName, align, textAlign, margin,
        padding, iconLeft, iconRight, maxWidth,
        delay, currentElement, lightBot,
        ...other
    } = props

    const handleButtonClick = (e: React.MouseEvent) => {
        // Check if it's a real mouse click (not synthetic from keyboard)
        // A synthetic click from Space key has detail = 0
        if (e.detail !== 0) {
            onClick()
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            onClick()
        }
    }

    const iconLeftSelected = () => {
        if (iconLeft?.svg) {
            // eslint-disable-next-line react/no-danger
            return <div aria-hidden='true' dangerouslySetInnerHTML={{__html: iconLeft?.svg}} />
        } else if (iconLeft?.src) {
            return <img aria-hidden='true' src={iconLeft?.src} />
        }
        return <div />
    }

    const iconRightSelected = () => {
        if (iconRight?.svg) {
            // eslint-disable-next-line react/no-danger
            return <div aria-hidden='true' dangerouslySetInnerHTML={{__html: iconRight?.svg}} />
        } else if (iconRight?.src) {
            return <img aria-hidden='true' src={iconRight?.src} />
        }
        return <div />
    }

    const isErrorVisible = errorId ? document.getElementById(errorId)?.getAttribute('aria-hidden') === 'false' : false

    return (
        <StyledRadioWrapper
            align={align}
            clearAfter={clearAfter}
            css={{
                $$delay: `${delay}s`,
                margin,
            }}
            currentElement={currentElement}
            hide={hide}
            inline={inline}
            lightBot={lightBot}
            textAlign={textAlign}
        >
            <StyledRadioWrapperInner css={{maxWidth}} >
                <label
                    onClick={handleButtonClick}
                    onKeyDown={handleKeyDown}
                >
                    <input
                        aria-invalid={isErrorVisible ? 'true' : 'false'}
                        checked={checked}
                        id={id}
                        name={name}
                        onChange={() => {
                            onChange({
                                groupName,
                                name,
                                readableName,
                                value,
                            })
                        }}
                        type='radio'
                        {...other}
                    />
                    <StyledRadioButton
                        checked={checked}
                        css={{padding}}
                    >{iconLeftSelected()}<span>{text}</span>{iconRightSelected()}
                    </StyledRadioButton>
                </label>
            </StyledRadioWrapperInner>
        </StyledRadioWrapper>
    )
}

QuestionnaireRadio.defaultProps = {
    errorId: '',
    align: '',
    delay: 0,
    lightBot: false,
    currentElement: false,
    textAlign: '',
    checked: false,
    groupName: '',
    iconLeft: {},
    iconRight: {},
    hide: false,
    inline: false,
    maxWidth: '',
    padding: '',
    margin: '',
    readableName: '',
    text: '',
    clearAfter: false,
}
